 import axios from "../../axiosInstance";

 const login_base_api = "/loginCntrl";

class LoginServices  {
  
    getLogin(logindetails){
        return axios.post(login_base_api+"/Login",logindetails);
    }

}

export default new LoginServices();